// Setando esta variável como true, o site inteiro irá se adaptar para a Black Friday
// Setando como false, o site irá voltar ao normal
export const isBlackFriday = false;
